export default class TicketNameService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getAll (params = {}) {
    return new Promise((resolve, reject) => {
      this.$http.get('predefined-ticket-names', { params })
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data)
        })
        .catch(reject)
    })
  }

  create (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('predefined-ticket-names', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  update (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.put(`predefined-ticket-names/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  destroy (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`predefined-ticket-names/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  reorder (orders) {
    return new Promise((resolve, reject) => {
      this.$http.patch('predefined-ticket-names/reorder', { orders })
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSettings () {
    return new Promise((resolve, reject) => {
      this.$http.get('predefined-ticket-names/settings')
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateSettings (settings) {
    return new Promise((resolve, reject) => {
      this.$http.post('predefined-ticket-names/settings', settings)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
